import React from "react";
import ReactDOM from "react-dom/client";
import {Provider} from "react-redux";

import "./include/bootstrap";
import "./include/styles";
import "./include/custom";

import * as windowService from "./services/windowService";

import App from "./containers/App";
import ErrorBoundary from "./components/ErrorBoundary";
import Error from "./components/Error";

import StoreProvider from "./models/StoreProvider";
import ImageStore from "./models/ImageStore";

export const initApp = (store, customStylePath = null) => {
    if (customStylePath !== null && !document.getElementById("custom-style")) {
        var link = document.createElement("link");
        link.id = "custom-style";
        link.rel = "stylesheet";
        link.type = "text/css";
        link.href = customStylePath;
        link.media = "all";

        document.getElementsByTagName("head")[0].appendChild(link);
    }

    window.storeProvider = new StoreProvider(store, windowService.isDebugMode());
    window.imageStore = new ImageStore();

    try {
        const root = ReactDOM.createRoot(document.getElementById("root"));

        window.onload = () => {
            root.render(
                <Provider store={store}>
                    <React.StrictMode>
                        <ErrorBoundary>
                            <App />
                        </ErrorBoundary>
                    </React.StrictMode>
                </Provider>
            );
        };
    } catch (error) {
        const errorRoot = ReactDOM.createRoot(document.getElementById("root"));

        window.onload = () => {
            errorRoot.render(
                <Provider store={store}>
                    <React.StrictMode>
                        <Error error={error.stack} />
                    </React.StrictMode>
                </Provider>
            );
        };
    }
};
